export enum COUNTRY_CODE {
  GERMANY = "DE",
  AUSTRIA = "AT",
  SWITZERLAND = "CH",
  POLAND = "PL",
  ENGLAND = "EN",
  ZULU = "ZU",
  CZECHIA = "CZ",
  SLOVAKIA = "SK",
  UNITED_KINGDOM = "GB",
  USA = "US",
  HUNGARY = "HU",
}

export enum SUPPORTED_MARKETS {
  DE = COUNTRY_CODE.GERMANY,
  PL = COUNTRY_CODE.POLAND,
  CZ = COUNTRY_CODE.CZECHIA,
  GB = COUNTRY_CODE.UNITED_KINGDOM,
  SK = COUNTRY_CODE.SLOVAKIA,
  US = COUNTRY_CODE.USA,
  HU = COUNTRY_CODE.HUNGARY,
}

export type SupportedMarket = (typeof SUPPORTED_MARKETS)[keyof typeof SUPPORTED_MARKETS];

export const PREVIEW_ONLY_MARKETS = [SUPPORTED_MARKETS.US, SUPPORTED_MARKETS.SK];

export type SupportedCountryPostcodes =
  | COUNTRY_CODE.GERMANY
  | COUNTRY_CODE.AUSTRIA
  | COUNTRY_CODE.SWITZERLAND
  | COUNTRY_CODE.POLAND
  | COUNTRY_CODE.USA
  | COUNTRY_CODE.UNITED_KINGDOM
  | COUNTRY_CODE.SLOVAKIA
  | COUNTRY_CODE.CZECHIA
  | COUNTRY_CODE.HUNGARY;

export enum CURRENCY_CODE {
  EUR = "EUR",
  PLN = "PLN",
  GBP = "GBP",
  CZK = "CZK",
  HUF = "HUF",
}

export type CurrencyCode = (typeof CURRENCY_CODE)[keyof typeof CURRENCY_CODE];
